import DOMPurify from 'dompurify';

// Sanitize text content (no HTML allowed)
export const sanitizeText = (dirty) => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, { ALLOWED_TAGS: [] });
};

// Sanitize HTML content (if needed in future)
export const sanitizeHTML = (dirty) => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty);
};